export default function baseStringSearch(item, queryText, itemText) {
  const baseQuery = queryText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const baseItemText = itemText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return baseItemText.indexOf(baseQuery) > -1;
}